// extracted by mini-css-extract-plugin
export default {"card":"ShelfForm_card__ZiI3T","selector":"ShelfForm_selector__Pndmw"};